import { motion } from "framer-motion";

const CHAPTERS = [
  {
    num: "01",
    title: "Architectural Audit",
    desc: "3D surface mapping and microbial risk assessment before any contract begins — so the plan fits your building, not a template.",
  },
  {
    num: "02",
    title: "Hospital-Grade Protocol",
    desc: "HEPA filtration and electrostatic sanitisation neutralising 99.99% of pathogens across every touchpoint.",
  },
  {
    num: "03",
    title: "Real-Time Quality App",
    desc: "Digital supervisor sign-offs uploaded to your client portal after every single shift. Proof, not promises.",
  },
  {
    num: "04",
    title: "Zero-Disruption Guarantee",
    desc: "Off-peak and nocturnal scheduling ensures your operations resume seamlessly at 7 AM, every day.",
  },
];

export const Manifesto = () => (
  <section
    id="protocol"
    data-testid="manifesto-section"
    className="relative py-24 sm:py-32"
  >
    <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-[1fr_1.4fr] gap-14">
      <div className="lg:sticky lg:top-32 self-start">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
        >
          <p className="eyebrow mb-4">The Gold Link Protocol</p>
          <h2 className="font-heading font-bold text-2xl sm:text-3xl lg:text-4xl tracking-tight text-ice-50 leading-snug mb-6">
            Four chapters.{" "}
            <span className="text-gold-500">Zero compromise.</span>
          </h2>
          <p className="text-base leading-relaxed text-ice-200/60 max-w-md">
            Every contract runs on the same disciplined framework — audited,
            certified and reported in real time.
          </p>
        </motion.div>
      </div>

      <div className="space-y-0">
        {CHAPTERS.map((c, i) => (
          <motion.div
            key={c.num}
            data-testid={`manifesto-chapter-${c.num}`}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.65, delay: i * 0.05 }}
            className="group border-t border-white/10 py-10 grid sm:grid-cols-[auto_1fr] gap-5 sm:gap-10 items-start hover:bg-navy-800/30 transition-colors duration-300 px-2 sm:px-4 -mx-2 sm:-mx-4 rounded-lg"
          >
            <span className="font-display font-black text-5xl sm:text-6xl text-outline group-hover:text-gold-500 group-hover:[-webkit-text-stroke:0px] transition-all duration-500 leading-none">
              {c.num}
            </span>
            <div>
              <h3 className="font-heading font-semibold text-xl sm:text-2xl text-ice-50 mb-3">
                {c.title}
              </h3>
              <p className="text-sm sm:text-base leading-relaxed text-ice-200/60 max-w-lg">
                {c.desc}
              </p>
            </div>
          </motion.div>
        ))}
        <div className="border-t border-white/10" />
      </div>
    </div>
  </section>
);
